import React from 'react';
import Navbar from './Navbar';
import ContactUs from './ContactUs';

function Privacy() {
  return (
    <div>
      <Navbar />
      <div style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          color: 'black',
          marginBottom: '2rem'
        }}>
          Privacy Policy
        </h1>

        {/* Content Box */}
        <div style={{
          backgroundColor: '#00000',
          padding: '2rem',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          color: '#1E4CA4', // Medium blue
          fontSize: '1rem',
          lineHeight: '1.8',
          whiteSpace: 'pre-wrap',
        }}>
          <p><strong>Article 1 - DEFINITIONS:</strong></p>
          <p>
            APPLICABLE MOBILE APPLICATION: This Privacy Policy will refer to and be applicable to the Mobile App listed above...
            {"\n"}EFFECTIVE DATE: Effective Date means the date this Privacy Policy comes into force and effect.
            {"\n"}PARTIES: The parties to this privacy policy are the following data controller...
            {"\n"}DATA CONTROLLER: Data Controller is the Party responsible for the collection...
            {"\n"}OPERATOR: Operator is the publisher, owner, and operator of the Mobile App...
            {"\n"}YOU: Should you agree to this Privacy Policy and continue your use...
            {"\n"}PERSONAL DATA: Personal DATA means personal data and information that we obtain...
          </p>

          <p><strong>Article 2 - GENERAL INFORMATION:</strong></p>
          <p>This privacy policy (hereinafter Privacy Policy) describes how we collect and use the Personal Data...</p>

          <p><strong>Article 3 - CONTACT:</strong></p>
          <p>The Party responsible for the processing of your personal data is the Bank...</p>

          <p><strong>Article 4 - LOCATION:</strong></p>
          <p>
            The Vilvattam Service Co-Opertive Bank Ltd.,
            {"\n"}Kurichikkare, Thrissur.P.O – 6800897
            {"\n"}Email : vilvattamscb337@gmail.com
          </p>

          <p><strong>Article 5 - MODIFICATIONS AND REVISIONS:</strong></p>
          <p>We reserve the right to modify, revise, or otherwise amend this Privacy Policy at any time...</p>

          <p><strong>Article 6 - THE PERSONAL DATA WE RECEIVE FROM YOU:</strong></p>
          <p>Depending on how you use our Mobile App, you will be subject to different types of Personal Data...</p>

          <p><strong>Article 7 - HOW PERSONAL DATA IS STORED:</strong></p>
          <p>We use secure physical and digital systems to store your Personal Data when appropriate...</p>

          <p><strong>Article 8 - PURPOSES OF PROCESSING OF PERSONAL DATA:</strong></p>
          <p>We primarily use your Personal Data to help us provide a better experience for you...</p>

          <p><strong>Article 9 - DISCLOSURE OF PERSONAL DATA:</strong></p>
          <p>Although our policy is to maintain the privacy of your Personal Data as described herein...</p>

          <p><strong>Article 10 - MODIFYING, DELETING, AND ACCESSING YOUR INFORMATION:</strong></p>
          <p>If you wish to modify or delete any information we may have about you...</p>

          <p><strong>Article 11 - YOUR RIGHTS:</strong></p>
          <p>
            You have many rights in relation to your Personal Data:
            {"\n"}- The right to be informed
            {"\n"}- The right to access
            {"\n"}- The right to correct or update
          </p>

          <p><strong>Article 12 - CONTACT INFORMATION:</strong></p>
          <p>If you have any questions or complaints, contact us at: www.vilvattamscb.com</p>
        </div>
      </div>
      <ContactUs/>
    </div>
  );
}

export default Privacy;
